import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const MyPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#FFF8E6',
          100: '#FFEFC2',
          200: '#FFE38A',
          300: '#FFD44D',
          400: '#FFC31A',
          500: '#FFA700',
          600: '#E69500',
          700: '#CC8400',
          800: '#996300',
          900: '#664200',
        },
        secondary: {
          50: '#E6FAF0',
          100: '#C2F2DA',
          200: '#8BE5B7',
          300: '#55D994',
          400: '#33CF7B',
          500: '#28C764', 
          600: '#22AD56',
          700: '#1C9348',
          800: '#157A3A',
          900: '#0F5629',
        },
        foreground: {
          DEFAULT: '#000000', 
        },
      },
      dark: {
        primary: {
          50: '#1F1A12',
          100: '#2B2318',
          200: '#3D301F',
          300: '#554222',
          400: '#77541C',
          500: '#996300', 
          600: '#B87416',
          700: '#D5891F',
          800: '#E6A23C',
          900: '#FFB84D',
        },
        secondary: {
          50: '#0F1A13',
          100: '#13261A',
          200: '#1A3B26',
          300: '#225433',
          400: '#2C7043',
          500: '#157A3A', 
          600: '#1E9C52',
          700: '#26B863',
          800: '#40D97C',
          900: '#63F29C',
        },
        foreground: {
          DEFAULT: '#FFFFFF', 
        },
        background: {
          DEFAULT: '#121212',
        },
      },
    },
  },
  components: {
    card: {
      body: {
        padding: '0',
      },
      colorScheme: {
        light: {
          root: {
            background: '{white.0}',
            color: '{foreground.DEFAULT}', 
          },
        },
        dark: {
          root: {
            background: '{surface.900}',
            color: '{foreground.DEFAULT}', 
          },
        },
      },
    },
    button: {
      colorScheme: {
        light: {
          info: {
            outlined: {
              root: {
                border: {
                  color: '#9B870C',
                },
              },
            },
          },
        },
      },
    },
    tooltip: {
      colorScheme: {
        light: {
          root: {
            background: '{primary.500}',
            color: '{surface.0}',
          },
          arrow: {
            background: '{primary.500}',
          },
        },
        dark: {
          root: {
            background: '{primary.500}',
            color: '{surface.0}',
          },
          arrow: {
            background: '{primary.500}',
          },
        },
      },
    },
  },
});
